import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/done-icon.png';
import _imports_1 from '@/assets/inprogress-icon.png';
const _withScopeId = (n) => (_pushScopeId("data-v-ae88fb00"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "estimateBlock"
};
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "dot" }, null, -1));
const _hoisted_3 = { class: "locationContainer" };
const _hoisted_4 = {
    key: 0,
    class: "locationBlock timeline intransit"
};
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "timeline-box" }, [
    /*#__PURE__*/ _createElementVNode("figure", { class: "done" }, [
        /*#__PURE__*/ _createElementVNode("img", {
            src: _imports_0,
            alt: "marker",
            width: "23",
            height: "26"
        })
    ])
], -1));
const _hoisted_6 = { class: "locationInfo" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "title" }, "Current Location", -1));
const _hoisted_8 = {
    key: 0,
    class: "desc"
};
const _hoisted_9 = {
    key: 1,
    class: "time"
};
const _hoisted_10 = { class: "locationBlock timeline" };
const _hoisted_11 = { class: "timeline-box" };
const _hoisted_12 = { key: 0 };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_1,
    alt: "marker",
    width: "12",
    height: "15"
}, null, -1));
const _hoisted_14 = [
    _hoisted_13
];
const _hoisted_15 = {
    key: 1,
    class: "done"
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: "marker",
    width: "23",
    height: "26"
}, null, -1));
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = { class: "locationInfo" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "title" }, "Customer Location", -1));
const _hoisted_20 = { class: "desc" };
const _hoisted_21 = {
    key: 0,
    class: "time"
};
import { computed, watch } from "vue";
import { TowVehicleServiceBookingStatus, } from "../../interfaces/main-data";
import { useStore } from "vuex";
import axios from "axios";
import { getAppName } from "../../apiConfig";
export default /*#__PURE__*/ _defineComponent({
    __name: 'LocationBlock',
    props: {
        data: {}
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const project = getAppName() || process.env.VUE_APP_NAME;
        // const gmapVisible = ref(false);
        const useTowVehicleTrueLocation = computed(() => store.getters.useTowVehicleTrueLocation);
        const fromLocation = computed(() => store.getters.vehicleDetails.position);
        const fromLiveLocation = computed(() => store.getters.liveLocation);
        const towVehicleStatus = computed(() => store.getters.towVehicleStatus);
        const address = computed(() => towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED
            ? store.getters.towVehicleInitialLocation ||
                props.data.towVehicleDetails?.locations?.[0]?.address
            : towVehicleStatus.value === TowVehicleServiceBookingStatus.ARRIVED
                ? props.data.customerLocation.address || props.data.customerLocation.line1
                : "");
        // const address = computed(() =>
        //   towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED
        //     ? store?.getters?.vehicleDetails?.position?.address ||
        //       props.data.towVehicleDetails?.locations?.[0]?.address
        //     : towVehicleStatus.value === TowVehicleServiceBookingStatus.ARRIVED
        //     ? props.data.customerLocation.address || props.data.customerLocation.line1
        //     : ""
        // );
        const toLocation = computed(() => props.data.customerLocation.location);
        const isDestinationReached = computed(() => store.getters.isDestinationReached);
        // function toggle() {
        //   gmapVisible.value = !gmapVisible.value;
        // }
        function haversine(lat1, lon1, lat2, lon2) {
            const R = 6371; // Radius of the Earth in km
            const dLat = (lat2 - lat1) * (Math.PI / 180);
            const dLon = (lon2 - lon1) * (Math.PI / 180);
            const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(lat1 * (Math.PI / 180)) *
                    Math.cos(lat2 * (Math.PI / 180)) *
                    Math.sin(dLon / 2) *
                    Math.sin(dLon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return R * c;
        }
        const distance = computed(() => {
            if (fromLocation.value && toLocation.value && project === "ultimate") {
                return haversine(fromLocation.value.latitude, fromLocation.value.longitude, toLocation.value.latitude, toLocation.value.longitude).toFixed(2);
            }
            if (fromLiveLocation.value &&
                fromLiveLocation.value.pos &&
                toLocation.value &&
                project !== "ultimate") {
                return haversine(fromLiveLocation.value.pos.y, fromLiveLocation.value.pos.x, toLocation.value.latitude, toLocation.value.longitude).toFixed(2);
            }
            return "0.00";
        });
        const estimatedArrival = computed(() => {
            const distanceInKm = parseFloat(distance.value);
            const averageSpeed = 40; // km/h
            return ((distanceInKm / averageSpeed) * 60).toFixed(0); // Convert hours to minutes
        });
        // Call this function when distance is less than 1 km
        async function checkDistance() {
            const distanceInKm = parseFloat(distance.value);
            const rad = useTowVehicleTrueLocation.value ? 0.5 : 1000;
            console.log("rad", useTowVehicleTrueLocation.value, rad);
            if (distanceInKm < rad) {
                store.commit("setIsDestinationReached", true);
            }
        }
        watch(distance, () => {
            checkDistance();
        });
        watch(fromLiveLocation, async () => {
            const gMapKey = process.env.VUE_APP_GOOGLE_MAP_API_KEY;
            const towVehicleInitialLocation = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${fromLiveLocation.value.pos.y},${fromLiveLocation.value.pos.x}&key=${gMapKey}`);
            store.commit("setTowVehicleInitialLocation", towVehicleInitialLocation?.data?.results?.[0].formatted_address);
        });
        // Open Google Maps in a new tab
        function openMap() {
            const latitude = props.data.customerLocation.location.latitude;
            const longitude = props.data.customerLocation.location.longitude;
            const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
            window.open(googleMapsUrl, "_blank");
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", null, [
                    (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).STARTED)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            (isDestinationReached.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" You have arrived at the customer location. ")
                                ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" Estimated arrival " + _toDisplayString(estimatedArrival.value) + " mins ", 1),
                                    _hoisted_2,
                                    _createTextVNode(" " + _toDisplayString(distance.value) + " km ", 1)
                                ], 64))
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, [
                        (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).STARTED ||
                            towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).ARRIVED)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _hoisted_5,
                                _createElementVNode("div", _hoisted_6, [
                                    _hoisted_7,
                                    (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).STARTED ||
                                        towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).ARRIVED)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(address.value), 1))
                                        : _createCommentVNode("", true),
                                    (_ctx.data.towVehicleDetails?.startedAt)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Started At " + _toDisplayString(new Date(_ctx.data.towVehicleDetails.startedAt).toLocaleString("en-US", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                            timeZone: _ctx.data.timeZone,
                                        })), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                ((towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).STARTED &&
                                    !isDestinationReached.value) ||
                                    towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).PENDING)
                                    ? (_openBlock(), _createElementBlock("figure", _hoisted_12, _hoisted_14))
                                    : _createCommentVNode("", true),
                                ((towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).STARTED &&
                                    isDestinationReached.value) ||
                                    towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).ARRIVED)
                                    ? (_openBlock(), _createElementBlock("figure", _hoisted_15, _hoisted_17))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                                _hoisted_19,
                                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.data.customerLocation.address || _ctx.data.customerLocation.line1), 1),
                                (_ctx.data.towVehicleDetails?.arrivedAt)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, " Arrived At " + _toDisplayString(new Date(_ctx.data.towVehicleDetails.arrivedAt).toLocaleString("en-US", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true,
                                        timeZone: _ctx.data.timeZone,
                                    })), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("button", { onClick: openMap }, "View on map")
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
